import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-banner',
  imports: [RouterLink],
  templateUrl: './cookie-consent-banner.component.html',
  styleUrl: './cookie-consent-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentBannerComponent {
  private cookieConsentService = inject(CookieConsentService);

  promptOpen = this.cookieConsentService.promptOpen;

  accept(): void {
    this.cookieConsentService.acceptAll();
  }

  reject(): void {
    this.cookieConsentService.rejectAll();
  }
}
